<template>
  <form class="validate-form" @submit.prevent="handleSignUp">
    <h2 class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
      {{ $t('public.signUp') }}
    </h2>
    <div class="mt-5">
      <a href="https://cdn.tatrykompas.sk/docs/sign_up_guide.pdf" target="_blank" class="btn btn-primary py-3 px-4 xl:mr-3 align-top">
        {{ $t('common.signUpGuide') }}
      </a>
    </div>
    <div class="intro-x mt-8">
      <div id="faq-accordion-1" class="accordion">
        <div class="accordion-item">
          <div id="faq-accordion-content-1" class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-accordion-collapse-1"
              aria-expanded="true"
              aria-controls="faq-accordion-collapse-1"
              :class="{
                'btn-danger': validate.email.$error || validate.phoneNumber.$error
              }"
            >
              {{ $t('common.contactData') }}
            </button>
          </div>
          <div
            id="faq-accordion-collapse-1"
            class="accordion-collapse collapse show"
            aria-labelledby="faq-accordion-content-1"
            data-bs-parent="#faq-accordion-1"
          >
            <div class="accordion-body text-gray-700 dark:text-gray-600 leading-relaxed">
              <div class="mt-3">
                <label for="name" class="form-label w-full flex flex-col sm:flex-row">
                  {{ $t('common.personName') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }},
                    {{ $t('form.constraint.gte2ch') }}
                  </span>
                </label>
                <input
                  id="name"
                  v-model.trim="validate.name.$model"
                  type="text"
                  name="name"
                  class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                  :class="{ 'border-theme-6': validate.name.$error }"
                  placeholder="John"
                />
                <template v-if="validate.name.$error">
                  <div
                    v-for="(error, index) in validate.name.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label for="lastname" class="form-label w-full flex flex-col sm:flex-row">
                  {{ $t('common.personLastname') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }},
                    {{ $t('form.constraint.gte2ch') }}
                  </span>
                </label>
                <input
                  id="lastname"
                  v-model.trim="validate.lastname.$model"
                  type="text"
                  name="lastname"
                  class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                  :class="{ 'border-theme-6': validate.lastname.$error }"
                  placeholder="Doe"
                />
                <template v-if="validate.lastname.$error">
                  <div
                    v-for="(error, index) in validate.lastname.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label for="email" class="form-label w-full flex flex-col sm:flex-row">
                  Email
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}
                  </span>
                </label>
                <input
                  id="email"
                  v-model.trim="validate.email.$model"
                  type="email"
                  name="email"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.email.$error }"
                  placeholder="info@tatrykompas.sk"
                />
                <template v-if="validate.email.$error">
                  <div
                    v-for="(error, index) in validate.email.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label for="password" class="form-label w-full flex flex-col sm:flex-row">
                  {{ $t('common.password') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}, {{ $t('form.constraint.passwordFormat') }}
                  </span>
                </label>
                <input
                  id="password"
                  v-model.trim="validate.password.$model"
                  type="password"
                  name="password"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.password.$error }"
                  placeholder="tajne heslo"
                />
                <template v-if="validate.password.$error">
                  <div
                    v-for="(error, index) in validate.password.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label
                  for="phoneNumber"
                  class="form-label w-full flex flex-col sm:flex-row"
                >
                  {{ $t('common.phoneNumber') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}, {{ $t('form.constraint.phoneFormat') }}
                  </span>
                </label>
                <input
                  id="phoneNumber"
                  v-model.trim="validate.phoneNumber.$model"
                  type="text"
                  name="phoneNumber"
                  class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                  :class="{ 'border-theme-6': validate.phoneNumber.$error }"
                  placeholder="+421xxxyyyzzz"
                />
                <template v-if="validate.phoneNumber.$error">
                  <div
                    v-for="(error, index) in validate.phoneNumber.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label for="web" class="form-label w-full flex flex-col sm:flex-row">
                  Web
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.optional') }}
                  </span>
                </label>
                <input
                  id="web"
                  v-model.trim="validate.web.$model"
                  type="text"
                  name="web"
                  class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                  :class="{ 'border-theme-6': validate.web.$error }"
                  placeholder="https://www.tatryapp.com/"
                />
                <template v-if="validate.web.$error">
                  <div
                    v-for="(error, index) in validate.web.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label for="iban" class="form-label w-full flex flex-col sm:flex-row">
                  IBAN
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.optional') }}
                  </span>
                </label>
                <input
                  id="iban"
                  v-model.trim="validate.iban.$model"
                  type="text"
                  name="iban"
                  class="intro-y form-control py-3 px-4 box pr-10 placeholder-theme-13"
                  :class="{ 'border-theme-6': validate.iban.$error }"
                  placeholder="SK00 0000 0000 0000 0000 0000"
                />
                <template v-if="validate.iban.$error">
                  <div
                    v-for="(error, index) in validate.iban.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <div id="faq-accordion-content-2" class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-accordion-collapse-2"
              aria-expanded="false"
              aria-controls="faq-accordion-collapse-2"
              :class="{
                'btn-danger': validate.businessName.$error || validate.businessId.$error
              }"
            >
              {{ $t('common.companyData') }}
            </button>
          </div>
          <div
            id="faq-accordion-collapse-2"
            class="accordion-collapse collapse"
            aria-labelledby="faq-accordion-content-2"
            data-bs-parent="#faq-accordion-1"
          >
            <div class="accordion-body text-gray-700 dark:text-gray-600 leading-relaxed">
              <div class="mt-3">
                <label
                  for="businessName"
                  class="form-label w-full flex flex-col sm:flex-row"
                >
                  {{ $t('public.businessName') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}
                  </span>
                </label>
                <input
                  id="businessName"
                  v-model.trim="validate.businessName.$model"
                  type="text"
                  name="businessName"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.businessName.$error }"
                />
                <template v-if="validate.businessName.$error">
                  <div
                    v-for="(error, index) in validate.businessName.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label
                  for="businessId"
                  class="form-label w-full flex flex-col sm:flex-row"
                >
                  {{ $t('public.businessId') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}
                  </span>
                </label>
                <input
                  id="businessId"
                  v-model.trim="validate.businessId.$model"
                  type="text"
                  name="businessId"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.businessId.$error }"
                />
                <template v-if="validate.businessId.$error">
                  <div
                    v-for="(error, index) in validate.businessId.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label for="taxId" class="form-label w-full flex flex-col sm:flex-row">
                  {{ $t('public.taxId') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.optional') }}
                  </span>
                </label>
                <input
                  id="taxId"
                  v-model.trim="validate.taxId.$model"
                  type="text"
                  name="taxId"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.taxId.$error }"
                />
                <template v-if="validate.taxId.$error">
                  <div
                    v-for="(error, index) in validate.taxId.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
              <div class="mt-3">
                <label
                  for="vatRegistrationId"
                  class="form-label w-full flex flex-col sm:flex-row"
                >
                  {{ $t('public.vatRegistrationId') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.optional') }}
                  </span>
                </label>
                <input
                  id="vatRegistrationId"
                  v-model.trim="validate.vatRegistrationId.$model"
                  type="text"
                  name="vatRegistrationId"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.vatRegistrationId.$error }"
                />
                <template v-if="validate.vatRegistrationId.$error">
                  <div
                    v-for="(error, index) in validate.vatRegistrationId.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <div id="faq-accordion-content-3" class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#faq-accordion-collapse-3"
              aria-expanded="false"
              aria-controls="faq-accordion-collapse-3"
              :class="{
                'btn-danger':
                  validate.street.$error ||
                  validate.streetNumber.$error ||
                  validate.city.$error ||
                  validate.zip.$error
              }"
            >
              {{ $t('address.label') }}
            </button>
          </div>
          <div
            id="faq-accordion-collapse-3"
            class="accordion-collapse collapse"
            aria-labelledby="faq-accordion-content-3"
            data-bs-parent="#faq-accordion-1"
          >
            <div class="accordion-body text-gray-700 dark:text-gray-600 leading-relaxed">
              <div class="mt-3">
                <label for="street" class="form-label w-full flex flex-col sm:flex-row">
                  {{ $t('address.street') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}
                  </span>
                </label>
                <input
                  id="street"
                  v-model.trim="validate.street.$model"
                  type="text"
                  name="street"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.street.$error }"
                />
                <template v-if="validate.street.$error">
                  <div
                    v-for="(error, index) in validate.street.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>

              <div class="mt-3">
                <label
                  for="streetNumber"
                  class="form-label w-full flex flex-col sm:flex-row"
                >
                  {{ $t('address.streetNumber') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}
                  </span>
                </label>
                <input
                  id="streetNumber"
                  v-model.trim="validate.streetNumber.$model"
                  type="text"
                  name="streetNumber"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.streetNumber.$error }"
                />
                <template v-if="validate.streetNumber.$error">
                  <div
                    v-for="(error, index) in validate.streetNumber.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>

              <div class="mt-3">
                <label for="city" class="form-label w-full flex flex-col sm:flex-row">
                  {{ $t('address.city') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}
                  </span>
                </label>
                <input
                  id="city"
                  v-model.trim="validate.city.$model"
                  type="text"
                  name="city"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.city.$error }"
                />
                <template v-if="validate.city.$error">
                  <div
                    v-for="(error, index) in validate.city.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>

              <div class="mt-3">
                <label for="zip" class="form-label w-full flex flex-col sm:flex-row">
                  {{ $t('address.zip') }}
                  <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
                    {{ $t('form.required') }}, {{ $t('form.constraint.zipFormat') }}
                  </span>
                </label>
                <input
                  id="zip"
                  v-model.trim="validate.zip.$model"
                  type="text"
                  name="zip"
                  class="intro-x login__input form-control py-3 px-4 border-gray-300 block mt-4"
                  :class="{ 'border-theme-6': validate.zip.$error }"
                />
                <template v-if="validate.zip.$error">
                  <div
                    v-for="(error, index) in validate.zip.$errors"
                    :key="index"
                    class="text-theme-6 mt-2"
                  >
                    {{ $t(error.$message) }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
        <div class="form-check flex-col items-start mt-3">
          <label for="toc" class="form-check-label ml-0 mb-2">
            {{ $t('common.agreeTo') }}
            <a
              href="https://cdn.tatrykompas.sk/docs/VOP.pdf"
              target="_blank"
              class="underline"
              >{{ $t('common.toc') }}</a
            >
          </label>
          <input
            id="toc"
            v-model="validate.toc.$model"
            name="toc"
            class="form-check-switch"
            type="checkbox"
          />
          <template v-if="validate.toc.$error">
            <div
              v-for="(error, index) in validate.toc.$errors"
              :key="index"
              class="text-theme-6 mt-2"
            >
              {{ $t(error.$message) }}
            </div>
          </template>
        </div>
        <div class="form-check flex-col items-start mt-3">
          <label for="gdpr" class="form-check-label ml-0 mb-2">
            {{ $t('common.agreeTo') }}
            <a
              href="https://www.tatrykompas.sk/consent"
              target="_blank"
              class="underline"
              >{{ $t('common.gdpr') }}</a
            >
          </label>
          <input
            id="gdpr"
            v-model="validate.gdpr.$model"
            name="gdpr"
            class="form-check-switch"
            type="checkbox"
          />
          <template v-if="validate.gdpr.$error">
            <div
              v-for="(error, index) in validate.gdpr.$errors"
              :key="index"
              class="text-theme-6 mt-2"
            >
              {{ $t(error.$message) }}
            </div>
          </template>
        </div>
      </div>
      <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
        <button
          class="btn btn-primary py-3 px-4 w-full xl:mr-3 align-top"
          type="submit"
          v-if="!loading"
        >
          {{ $t('public.signUpRequest') }}
        </button>
        <div
          class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center"
          v-if="loading"
        >
          <LoadingIcon icon="three-dots" class="w-8 h-8" />
        </div>
      </div>
      <div class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-3">
        <router-link :to="{ name: 'login' }" tag="a">
          {{ $t('public.loginIn') }}
        </router-link>
      </div>
    </div>
  </form>
  <!-- BEGIN: Success Notification Content -->
  <div id="success-notification-content" class="toastify-content hidden flex">
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('public.signUpSuccessfull') }}!</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('public.signUpFailed') }}!</div>
      <div class="text-gray-600 mt-1">{{ $t('form.checkData') }}</div>
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, toRefs, reactive, ref } from 'vue'
import { required, helpers, email, minLength, sameAs } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import Toastify from 'toastify-js'

export default defineComponent({
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/')
    }
  },
  methods: {
    handleSignUp(data) {
      this.loading = true

      this.validate.$touch()
      if (this.validate.$invalid) {
        Toastify({
          node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.loading = false
        return
      }

      this.$store.dispatch('auth/signUp', this.formData).then(
        () => {
          this.signedUp = true
          this.loading = false
          Toastify({
            node: cash('#success-notification-content').clone().removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.$router.push('/')
        },
        (error) => {
          this.loading = false
          Toastify({
            node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.message =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            error.toString()
        }
      )
    }
  },
  setup() {
    const loading = ref(false)
    const phoneNumberValidator = helpers.regex(/^\+421[0-9]{9}$/)
    const zipValidator = helpers.regex(/^\s*\d\s*\d\s*\d\s*\d\s*\d\s*$/)
    const ibanValidator = helpers.regex(
      /^SK\d{2}\s?\d{4}\s?\d{4}\s?\d{2}[0-9A-Za-z]{2}\s[0-9A-Za-z]{4}\s[0-9A-Za-z]{4}?$/
    )
    const passwordValidator = helpers.regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/
    )
    const formData = reactive({
      name: '',
      lastname: '',
      email: '',
      password: '',
      phoneNumber: '',
      web: '',
      iban: '',
      businessName: '',
      businessId: '',
      taxId: '',
      vatRegistrationId: '',
      street: '',
      streetNumber: '',
      city: '',
      zip: '',
      state: 'SVK',
      toc: false,
      gdpr: false
    })
    const rules = {
      name: {
        required: helpers.withMessage('form.validation.personName.required', required),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      lastname: {
        required: helpers.withMessage(
          'form.validation.personLastname.required',
          required
        ),
        minLength: helpers.withMessage('form.validation.gte2ch', minLength(2))
      },
      email: {
        required: helpers.withMessage('form.validation.requiredField', required),
        email: helpers.withMessage('form.validation.email', email)
      },
      password: {
        required: helpers.withMessage('form.validation.requiredField', required),
        passwordValidator: helpers.withMessage(
          'form.validation.password',
          passwordValidator
        )
      },
      phoneNumber: {
        required: helpers.withMessage('form.validation.requiredField', required),
        phoneNumberValidator: helpers.withMessage(
          'form.validation.phoneNumberValidator',
          phoneNumberValidator
        )
      },
      web: {},
      iban: {
        ibanValidator: helpers.withMessage('form.validation.ibanValidator', ibanValidator)
      },
      businessName: {
        required: helpers.withMessage('form.validation.requiredField', required)
      },
      businessId: {
        required: helpers.withMessage('form.validation.requiredField', required)
      },
      taxId: {},
      vatRegistrationId: {},
      street: {
        required: helpers.withMessage('form.validation.requiredField', required)
      },
      streetNumber: {
        required: helpers.withMessage('form.validation.requiredField', required)
      },
      city: {
        required: helpers.withMessage('form.validation.requiredField', required)
      },
      zip: {
        required: helpers.withMessage('form.validation.requiredField', required),
        zipValidator: helpers.withMessage('form.validation.zipValidator', zipValidator)
      },
      state: {},
      toc: {
        required: helpers.withMessage('form.validation.requiredField', sameAs(true))
      },
      gdpr: {
        required: helpers.withMessage('form.validation.requiredField', sameAs(true))
      }
    }
    const validate = useVuelidate(rules, toRefs(formData))

    return {
      loading,
      validate,
      formData
    }
  }
})
</script>
